import { flexRender, type Table } from '@tanstack/react-table';
import { Pencil } from 'lucide-react';
import type { ReactNode } from 'react';
import { Panel } from './primitives';

interface GridTableProps<T> {
  table: Table<T>;
  /** `grid-template-columns` das linhas. */
  columns: string;
  minWidth: number;
  empty?: ReactNode;
  footer?: ReactNode;
}

/** Tabela em grid (cabeçalho em caixa alta, linhas com hover) dentro de um card. */
export function GridTable<T>({
  table,
  columns,
  minWidth,
  empty,
  footer,
}: GridTableProps<T>) {
  const rows = table.getRowModel().rows;

  return (
    <Panel className="overflow-hidden">
      <div className="overflow-x-auto">
        <div style={{ minWidth }}>
          {table.getHeaderGroups().map((group) => (
            <div
              key={group.id}
              className="grid gap-4 border-b border-line bg-surface-2 px-6 py-3 text-[10px] font-bold tracking-[.1em] text-muted"
              style={{ gridTemplateColumns: columns }}
            >
              {group.headers.map((header) => (
                <span key={header.id}>
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </span>
              ))}
            </div>
          ))}
          {rows.map((row) => (
            <div
              key={row.id}
              className="grid items-center gap-4 border-b border-line px-6 py-3.5 transition-colors hover:bg-surface-2"
              style={{ gridTemplateColumns: columns }}
            >
              {row.getVisibleCells().map((cell) => (
                <div key={cell.id} className="min-w-0">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              ))}
            </div>
          ))}
          {rows.length === 0 && empty && (
            <div className="px-6 py-12 text-center text-sm text-muted">{empty}</div>
          )}
        </div>
      </div>
      {footer}
    </Panel>
  );
}

export function EditIconButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      title="Editar"
      onClick={onClick}
      className="flex size-[34px] items-center justify-center rounded-[10px] border border-line text-muted transition-colors hover:border-brand hover:text-brand"
    >
      <Pencil className="size-4" />
    </button>
  );
}
